import { AnySimple, NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../../serviceRequestBase';
import { CoreFile } from '../../core/files/files.contractparts';

export class ApplicationFieldChangeRequestBody extends NaniumObject<ApplicationFieldChangeRequestBody> {
	@Type(String) applicationId: string;
	@Type(String) fieldName: string;
	@Type(AnySimple) value?: any;
	@Type(CoreFile) file?: any;
}

@RequestType({
	responseType: AnySimple,
	genericTypes: { TRequestBody: ApplicationFieldChangeRequestBody },
	scope: 'public'
})
export class ApplicationFieldChangeRequest extends ServiceRequestBase<ApplicationFieldChangeRequestBody, any> {
	static serviceName: string = 'EduApplication:application/field/change';
}
